import { render, staticRenderFns } from "./BaseDataForm.vue?vue&type=template&id=414dc4d0&scoped=true&"
import script from "./BaseDataForm.vue?vue&type=script&lang=js&"
export * from "./BaseDataForm.vue?vue&type=script&lang=js&"
import style0 from "./BaseDataForm.vue?vue&type=style&index=0&id=414dc4d0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "414dc4d0",
  null
  
)

export default component.exports